import { render } from "./DefaultLoader.vue?vue&type=template&id=6cf7970a&scoped=true"
import script from "./DefaultLoader.vue?vue&type=script&lang=js"
export * from "./DefaultLoader.vue?vue&type=script&lang=js"

import "./DefaultLoader.vue?vue&type=style&index=0&id=6cf7970a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf7970a"]])

export default __exports__